import { nanoid } from 'nanoid';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from '#src/shared/error';

import type { PetitionGuidesLandingPageDataQuery, PetitionGuidesLandingPageDataQueryVariables } from './api.graphql';
import { PetitionGuidesLandingPageData } from './api.graphql';

export type PetitionGuidesPageData = NonNullable<PetitionGuidesLandingPageDataQuery['landingPage']> & {
	aiSapId: string;
	categories: PetitionGuidesLandingPageDataQuery['categories'];
};

export async function getPetitionGuidesPageData(
	{ gql: { fetch } }: UtilityContext,
	_: string,
): Promise<PetitionGuidesPageData> {
	const { data } = await fetch<PetitionGuidesLandingPageDataQuery, PetitionGuidesLandingPageDataQueryVariables>({
		query: PetitionGuidesLandingPageData,
		rejectOnError: true,
	});

	if (!data.landingPage) {
		throw new NotFoundError();
	}

	return {
		...data.landingPage,
		aiSapId: nanoid(),
		categories: data.categories,
	};
}
